import React, { useEffect, useState } from "react";
import { Space, Table } from "antd";
import parser from "../../../../../shared/helpers/parser";
import DeleteButton from "../../../../../shared/components/deleteButton";
import EditButton from "../../../../../shared/components/editButton";
import Utils from "../../../../../shared/helpers/utils";
import ReferenciasApi from "../../../../referencias/api/ReferenciasApi";

const AnexoIContratistasTable = props => {
  const [ciius, setCiius] = useState([]);

  useEffect(() => {
    ReferenciasApi.GetTabla("PUBLICACIONES.CIIU").then((response) => { setCiius(response); })
  }, []);

  return (
    <Table
      size="small"
      columns={ [
        { title: 'Id', dataIndex: 'IdContratista', key: 'IdContratista' },
        { title: 'Cuit', dataIndex: 'Cuit', key: 'Cuit' },
        { title: 'Ciiu', dataIndex: 'Ciiu', key: 'Ciiu',
          render: text => Utils.getIdDesc(text, ciius) 
        },
        { title: 'Cantidad Trabajadores', dataIndex: 'CantidadTrabajadores', key: 'CantidadTrabajadores' },
        //{ title: 'Fecha Insert', dataIndex: 'FechaInsert', key: 'FechaInsert', render: text => <span>{ parser.date(text) }</span> },
        props.formMode ? { title: '', dataIndex: 'Actions', key: 'Actions',
          render: (text, record) => {
            return <Space size="small">
              <EditButton onClick={ () => props.onEdit(record) }/>
              <DeleteButton onConfirm={ () => props.onRemove(record) }/>
              {/* { !record.IdContratista ? <DeleteButton onConfirm={ () => props.onRemove(record) }/> : '' } */}
            </Space>
          }
        } : {},
      ] } 
      dataSource={ props.Contratistas }
      rowKey={(record) => record.Id}
      pagination={ { hideOnSinglePage: true, pageSize: 10, showSizeChanger: false } }
    />
  );
}

export default AnexoIContratistasTable;